/* 
Notes:
27112022 (Eddril) Used Fetch for Async/Await, Filter Fix
*/

import React, { useEffect, useState } from 'react';
import { Col, Row, Tabs, Tab } from 'react-bootstrap';
import { CardWorkatoConnector } from './card-workato-connector';

const WorkatoConnectors = (props) => {
  const [connectionsData, setConnectionsData] = useState();
  useEffect(() => {
    setConnectionsData(props.connectionsData);
  }, [props.connectionsData, props.connectionTab]);

  return (
    <>
      <Row>
        <Col lg={12}>
          <Row className="tabs-connection">
            <Tabs id="" className="mb-3">
              {connectionsData
                ? connectionsData
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((filterConnection, key) => {
                      return (
                        <Tab eventKey={filterConnection.provider} title={filterConnection.name} key={key}>
                          <CardWorkatoConnector
                            key={filterConnection.id}
                            connectionName={filterConnection.name}
                            connectionId={filterConnection.id}
                          />
                        </Tab>
                      );
                    })
                : null}
            </Tabs>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export { WorkatoConnectors };
